module.exports = __webpack_public_path__ + "img/img-contacto.34fa3a54.png";